import React from 'react';
import "tabler-react/dist/Tabler.css";
import { Card, Dimmer } from "tabler-react";

import TablaPlataformas from "./TablaPlataformas";

function CardTablaPlataformas() {
  return (
    <>
        <Card>
            <Card.Body>
                <Dimmer loader>
                    <TablaPlataformas />
                </Dimmer>
            </Card.Body>
        </Card>
    </>
  );
}

export default CardTablaPlataformas;